<template>
    <component
        :is="isExternalLink ? 'a' : 'Link'"
        :href="href"
        :target="openExternalLinkInNewTab && isExternalLink ? '_blank' : null"
        :prefetch="shouldPrefetch"
        cache-for="10s"
    >
        <slot></slot>
    </component>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
    name: 'DynamicLink',

    components: {
        Link,
    },

    props: {
        href: {
            type: String,
            required: true,
        },
        openExternalLinkInNewTab: {
            type: Boolean,
            default: true,
        },
        prefetch: {
            // Accepts a Boolean, String, or Array for prefetching options
            type: [Boolean, String, Array],
            default: true,
        },
    },

    computed: {
        isExternalLink() {
            try {
                return (
                    this.$page.props.appDomainHost !==
                    new URL(this.href).hostname
                )
            } catch (e) {
                return false
            }
        },

        isEditLink() {
            //ends with edit
            if (this.isExternalLink) {
                return false
            }
            return this.href.endsWith('edit')
        },

        shouldPrefetch() {
            return this.prefetch && !this.isExternalLink && !this.isEditLink
        },
    },
}
</script>
